import type { AlarmEscalationSettings } from '@empower-safety/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client.js';

export function useEscalationSettings() {
  const api = useApi();
  return useQuery({
    queryKey: ['organisation', 'escalation-settings'],
    queryFn: () => api<AlarmEscalationSettings>('/organisations/escalation-settings'),
    staleTime: 60_000,
  });
}

export function useUpdateEscalationSettings() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<AlarmEscalationSettings>) =>
      api<AlarmEscalationSettings>('/organisations/escalation-settings', {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    onSuccess: (next) => {
      qc.setQueryData(['organisation', 'escalation-settings'], next);
    },
  });
}
